import "core-js/modules/es.array.iterator.js";
import clsx from 'clsx';
import { GridList } from '@isyc-react/animation/modules/grid';
import React from 'react';
import { DropPreview } from "../../../drop-preview";
import { getArchiveExtension, getArchiveIcon } from '@isyc-react/archives/view/tools';
import { IconButtonTransparent } from '@isyc-react/form/modules/button';
import "./drop-multi-file-status-grid.style.scss";
export const DropMultiFileGridItem = props => {
  var _item$file$name, _item$file, _item$api, _item$file$name2, _item$file2, _item$api2, _item$api3;
  const {
    item,
    remove
  } = props;
  const [preview, setPreview] = React.useState(false);
  const ext = getArchiveExtension((_item$file$name = (_item$file = item.file) === null || _item$file === void 0 ? void 0 : _item$file.name) !== null && _item$file$name !== void 0 ? _item$file$name : (_item$api = item.api) === null || _item$api === void 0 ? void 0 : _item$api.name);
  const classes = getArchiveIcon((_item$file$name2 = (_item$file2 = item.file) === null || _item$file2 === void 0 ? void 0 : _item$file2.name) !== null && _item$file$name2 !== void 0 ? _item$file$name2 : (_item$api2 = item.api) === null || _item$api2 === void 0 ? void 0 : _item$api2.name);
  const badge = React.useMemo(() => classes.hasPreview ? 'badge-info' : 'badge-secondary', [classes]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, ext && /*#__PURE__*/React.createElement("div", {
    className: "grid-file-item-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('badge badge-pill', badge)
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-light"
  }, ext.toUpperCase()))), /*#__PURE__*/React.createElement("div", {
    className: "grid-file-item-remove"
  }, /*#__PURE__*/React.createElement(IconButtonTransparent, {
    onClick: () => remove()
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-close",
    style: {
      color: '#CDCDCD'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center flex-column"
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx(classes.icon, 'font-size-75')
  }), /*#__PURE__*/React.createElement("small", {
    className: "text-muted mt-1"
  }, item.file ? /*#__PURE__*/React.createElement(React.Fragment, null, item.file.name) : /*#__PURE__*/React.createElement(React.Fragment, null, (_item$api3 = item.api) === null || _item$api3 === void 0 ? void 0 : _item$api3.name))), /*#__PURE__*/React.createElement("div", {
    className: "grid-file-item-view"
  }, /*#__PURE__*/React.createElement(IconButtonTransparent, {
    onClick: () => setPreview(true)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-eye",
    style: {
      color: '#CDCDCD'
    }
  }))), /*#__PURE__*/React.createElement(DropPreview, {
    value: item,
    show: preview,
    onChange: setPreview
  }));
};
export const DropMultiFileGrid = props => {
  var _value$accepted$map;
  const {
    common,
    status
  } = props;
  const {
    value
  } = common;
  const {
    remove
  } = status;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GridList, {
    items: (_value$accepted$map = value === null || value === void 0 ? void 0 : value.accepted.map(accepted => ({
      id: accepted.id,
      height: 400,
      render: /*#__PURE__*/React.createElement(DropMultiFileGridItem, {
        item: accepted,
        remove: () => remove(accepted.id)
      })
    }))) !== null && _value$accepted$map !== void 0 ? _value$accepted$map : []
  }));
};